import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import ContratoService from '../../../../services/contrato';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'



const FormBusca = (props) => {
    const [situacao, setSituacao] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");


    const busca = async (query) => {
        if (query === "") {
            props.setAindaTem(true)
            await props.fetchLicitantes()
            setContratado("")
            setCnpj("")
        } else {
            var response = await ContratoService.buscar(query)
            if (response.data.length >= 1) {
                const uniqueContratados = [...new Map(response.data.map(item => [item['cnpj'], item])).values()];
                props.setLicitantes(uniqueContratados)
                props.setAindaTem(false)
                props.setVazio(false)
                setContratado("")
                setCnpj("")
            } else {
                props.setVazio(true)
                setContratado("")
                setCnpj("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (contratado) prepQuery = prepQuery + `&contratado=${encodeURI(contratado)}`;
        if (cnpj) prepQuery = prepQuery + `&cnpj=${cnpj}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="contratado">
                                <FloatingLabel
                                    label="Razão Social do Licitante"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contratado"
                                        value={contratado}
                                        onChange={e => setContratado(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CPF/CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Concluído">Concluído</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Rescindido">Rescindido</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/contratos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row xs={1}>
                        <Col xs={12}>
                            <Exportar data={props.licitantes} nome={"Licitantes"} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca